import { Component, OnInit } from '@angular/core';
import {AdminService} from '../../shared/services/admin.service';
import {ModalService} from '../../shared/services/modal.service';
import {ModalAdminAccountComponent} from './modal-admin-account/modal-admin-account.component';
import {Subject} from 'rxjs';
import {empty} from '../../functions';
import {alertMessages, AlertService} from '../../shared/services/alert.service';
import {catchError} from 'rxjs/operators';
import { RoleTypes} from '../../guards/roletypes';
import {ModalAdminStudentprofileComponent} from '../admin-studentprofiles/modal-admin-studentprofile/modal-admin-studentprofile.component';
import {StudentService} from '../../shared/services/student.service';

@Component({
    selector: 'app-admin-accounts',
    templateUrl: './admin-accounts.component.html',
    styleUrls: ['./admin-accounts.component.scss'],
    standalone: false
})
export class AdminAccountsComponent implements OnInit {

  filterOpen = false;

  public RoleTypes = RoleTypes;

  public view = {
    filters: {
      queryParams: {
        SearchTerm: null,
        SortField: 'emailAddress',
        SortType: 'Ascending',
        Role: null,
      }
    },
    filterOptions: {
      areaOfInterests: <any>[],
      sites: <any>[],
      status: <any>[],
      educationLevels: <any>[],
    },

  };

  configTable = {
    hasPagination: true,
    columns: [
      {
        header_name: 'Email',
        name: 'emailAddress',
        type: 'text'
      },
      {
        header_name: 'First name',
        name: 'firstName',
        type: 'text'
      },
      {
        header_name: 'Last name',
        name: 'lastName',
        type: 'text'
      },
      {
        header_name: 'Phone number',
        name: 'phoneNumber',
        type: 'text'
      },
      {
        header_name: 'Roles',
        name: 'roles',
        type: 'array',
        field: ''
      },
    ],
    endpoint: 'account',
    data: <any> [],
    buttons: [
      {
        class: 'btn btn-danger',
        event: 'delete',
        text: 'Delete'
      },
      {
        class: 'btn btn-info',
        event: 'profile',
        text: 'Profile',
        closure: function(row: any): boolean
        {
          return (row.hasOwnProperty('roles') && row.roles.includes(RoleTypes.Student)) ? true : false;
        }
      },
      {
        class: 'btn btn-warning',
        event: 'edit',
        text: 'Edit'
      }
    ],
    class: '',
    reloadListener: new Subject(),
    queryParams: this.view.filters.queryParams
  };

  /**
   * Constructor
   *
   * @param modal
   * @param adminService
   * @param alertService
   */
  constructor(public modal:ModalService, public adminService: AdminService, private alertService: AlertService, public studentService: StudentService) {

  }

  /**
   * Ng on init
   */
  ngOnInit(): void {


  }

  /**
   * Add a single account
   */
  addAccount() {

    const data = {
      emailAddress: '',
      firstName: '',
      lastName: ''
    };
    const modalOptios = {
      backdrop: 'static',
      size: 'xl'
    }
    this.modal.Modal(ModalAdminAccountComponent, 'Account', '', data, [], modalOptios).then( (result) => {

      if (result === true) {

        this.alertService.success(alertMessages.successDataSaved);

        this.configTable.reloadListener.next(true);
      }

    }).catch( (error) => {

    });
  }

  /**
   * Update a single account
   *
   * @param $account
   */
  updateAccount($account: any) {

    const data = $account;

    const modalOptios = {
      backdrop: 'static',
      size: 'xl'
    }
    this.modal.Modal(ModalAdminAccountComponent, 'Account', '', data, [], modalOptios).then( (result) => {

      if (result === true) {
        this.alertService.success(alertMessages.successDataSaved);

        this.configTable.reloadListener.next(true);
      }

    }).catch( (error) => {

    });
  }

  /**
   * Update a single account
   *
   * @param $account
   */
  updateStudentprofile($data:any) {

    const modalOptions = {
      backdrop: 'static',
      size: 'xl'
    };

    this.studentService.apiGetStudentprofile($data['id']).subscribe( (result: any) => {

      if (result) {
        const data = {
          entity: result
        };

        this.modal.Modal(ModalAdminStudentprofileComponent, '', '', data, [], modalOptions).then( (result) => {

          if (result === true) {

            this.alertService.success(alertMessages.successDataSaved);

            this.configTable.reloadListener.next(true);
          }

        }).catch( (error) => {

        });

      }

    })


  }

  /**
   * Delete a single account
   *
   * @param $id
   */
  deleteAccount($id: string) {

    this.modal.Confirm('Delete', 'Are you sure you want to delete this?').then((confirm) => {

      if (confirm === true) {

        this.adminService.apiDeleteAccount($id).pipe(catchError(this.adminService.handleError('apiDeleteAccount', false))).subscribe( (result) => {

          if (result !== false) {
            this.alertService.success(alertMessages.successDataRemoved);
            this.configTable.reloadListener.next(true);
          }

        });

      }
       else {

      }
    }).catch((error) => {

    });
    this.adminService.apiDeleteAccount($id)
  }

  /**
   * Handle table button event
   *
   * @param $event
   */
  handleButtonEvent($event:any) {

    if (!empty($event['event'])) {

      switch ($event['event']) {

        case 'profile':
          if ($event['data'].hasOwnProperty('roles')) {
            if ($event['data']['roles'].includes(RoleTypes.Student)) {
              this.updateStudentprofile($event['data']);
              break;
            }
          }
          this.updateAccount($event['data']);
          break;

        case 'edit':
          this.updateAccount($event['data']);
          break;

        case 'delete':
          this.deleteAccount($event['data']['id']);
          break;
      }
    }

  }

  reloadData() {

    this.setQueryParams();

    this.configTable.reloadListener.next(true);
  }

  setQueryParams() {
    this.configTable.queryParams = this.view.filters.queryParams
  }

  resetFilters() {

    this.view.filters = {
      queryParams: {
        SearchTerm: null,
        SortField: 'createdOn',
        SortType: 'Descending',
        Role: null,
      }
    }

    this.reloadData();
  }

  applyFilters()
  {
    this.reloadData();
  }

}
